import {isTagValueStructuredTableColumn} from 'notebook/structured-tables/columns/TypePredicates';
import {
  LastSyncedUpstreamValue,
  StructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import getLastSyncedUpstreamValue from 'notebook/structured-tables/util/getLastSyncedUpstreamValue';
import {
  isResolvedRowDelegateColumn,
  ResolvedRowDelegateColumn,
} from 'notebook/structured-tables/util/resolveRowDelegateColumn';

/**
 * Returns the LastSyncedUpstreamValue for a given column.
 *
 * For ROW_DELEGATE columns, it falls back to matching the LSUV on the delegated column's UUID.
 */
export default function getLastSyncedUpstreamValueForColumn(
  lastSyncedUpstreamValues: Array<LastSyncedUpstreamValue>,
  column: StructuredTableColumn | ResolvedRowDelegateColumn
): LastSyncedUpstreamValue | null {
  const fieldApiId = isTagValueStructuredTableColumn(column) ? column.schemaFieldApiId : null;
  const lsuvKeyBase = {
    columnType: column.columnType,
    columnGroup: column.columnGroup ?? null,
    fieldId: fieldApiId,
  };
  let lsuv: LastSyncedUpstreamValue | null = getLastSyncedUpstreamValue(lastSyncedUpstreamValues, {
    ...lsuvKeyBase,
    columnProvenanceUuid: column.provenanceUuid ?? null,
  });
  // Fall back to matching the LSUV on the delegated column's UUID for older LSUVs. This logic can be
  // removed after BNCH-150280.
  if (!lsuv && isResolvedRowDelegateColumn(column)) {
    lsuv = getLastSyncedUpstreamValue(lastSyncedUpstreamValues, {
      ...lsuvKeyBase,
      columnProvenanceUuid: column.delegatedColumnProvenanceUuid,
    });
  }
  return lsuv;
}
